import styled from 'styled-components';
import { FlexRow } from '../../../../utils/styles/StyledUtils';

export const Container = styled(FlexRow)`
  height: 100%;
  position: relative;
`;
